import { render, staticRenderFns } from "./MediaCollectionCallout.vue?vue&type=template&id=39979721&scoped=true"
import script from "./MediaCollectionCallout.vue?vue&type=script&lang=js"
export * from "./MediaCollectionCallout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39979721",
  null
  
)

export default component.exports